import { Atom, Microscope } from "lucide-react";

import styles from "./ResultsDetailPlaceholder.module.css";

export const ResultsDetailPlaceholder = () => (
  <div className={styles.wrapper}>
    <div className={styles.illustration}>
      <div className={styles.iconCard}>
        <Microscope size={32} />
      </div>

      <div className={styles.iconCardOverlap}>
        <Atom size={32} />
      </div>
    </div>

    <div className={styles.text}>
      <p className={styles.title}>No results selected</p>
      <p className={styles.subtitle}>Select a result to see details here</p>
    </div>
  </div>
);
